module.exports = __webpack_public_path__ + "img/keyboard_ModeArea.c3abf3b7.png";